import { useEffect } from 'react'
import { Outlet, useParams, Navigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { supportedLanguages, defaultLanguage, type SupportedLanguage } from '../../i18n'

export default function LanguageRoute() {
  const { lang } = useParams<{ lang: string }>()
  const { i18n } = useTranslation()

  const isSupported = lang && (supportedLanguages as readonly string[]).includes(lang)

  useEffect(() => {
    if (isSupported && i18n.language !== lang) {
      i18n.changeLanguage(lang)
    }
  }, [lang, isSupported, i18n])

  if (!isSupported) {
    return <Navigate to={`/${defaultLanguage}`} replace />
  }

  return <Outlet />
}

/** Build a localized path, preserving the current language */
// eslint-disable-next-line react-refresh/only-export-components
export function useLocalePath() {
  const { lang } = useParams<{ lang: string }>()
  const currentLang = (lang ?? defaultLanguage) as SupportedLanguage

  return (path: string) => `/${currentLang}${path.startsWith('/') ? path : `/${path}`}`
}
